import React, { Component } from 'react';
import { Container, Row, Col, Breadcrumb } from 'react-bootstrap';
import { Styles } from "./styles/breadcrumb.js";
import { getAssetUrl } from '../../helper/assets';

export class BreadcrumbBox extends Component {
    state = {
        backgroundImage: 'breadcrumb-bg.jpg',
    }

    render() {
        const bgUrl = this.props.bgImage ? getAssetUrl(this.props.bgImage) : getAssetUrl(this.state.backgroundImage);
        return (
            <Styles>
                <section className="breadcrumb-area" style={{ backgroundImage: `url(${bgUrl})` }}>
                    <Container>
                        <Row>
                            <Col md="12" className="text-center">
                                <div className="breadcrumb-box">
                                    <h2 className="breadcrumb-title">{this.props.title}</h2>
                                    <Breadcrumb>
                                        <Breadcrumb.Item href={process.env.PUBLIC_URL + "/"}>Home</Breadcrumb.Item>
                                        {this.props.parentItem ? (
                                            <>
                                                <Breadcrumb.Item href={this.props.parentLink || "#"}>{this.props.parentItem}</Breadcrumb.Item>
                                                <Breadcrumb.Item active>{this.props.title}</Breadcrumb.Item>
                                            </>
                                        ) : (
                                            <Breadcrumb.Item active>{this.props.title}</Breadcrumb.Item>
                                        )}
                                    </Breadcrumb>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Styles>
        )
    }
}